import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { themed } from "../skins";
import { LightboxContextProvider } from "../context";
const _Lightbox = ({ visible = false, children, onChange, ...props }) => {
    const previousFocus = useRef(null);
    const lightboxRef = useRef(null);
    const onKeyUp = (e) => {
        if (e.key === "Escape") {
            e.stopPropagation();
            e.preventDefault();
            onChange?.(false);
        }
    };
    const handleCloseLightbox = React.useCallback(() => {
        onChange?.(false);
    }, [onChange]);
    useEffect(() => {
        if (visible) {
            previousFocus.current = document.activeElement;
            lightboxRef.current?.focus();
        }
        else {
            previousFocus.current?.focus();
        }
    }, [visible]);
    return visible
        ? createPortal(React.createElement(LightboxContextProvider, { value: { close: handleCloseLightbox } },
            React.createElement("div", { "data-testid": "lightbox", ...props, onClick: handleCloseLightbox, onKeyUp: onKeyUp, tabIndex: -1, ref: lightboxRef }, children)), document.body)
        : null;
};
export const Lightbox = themed(_Lightbox);
//# sourceMappingURL=Lightbox.js.map